import React from "react";
import ModalInfo from "./ModalInfo";

class RatingActivity extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    selectedGrade: 0,
    modalShow: false,
  };

  componentDidMount() {
    this.setState({ selectedGrade: this.props.grade });
  }

  render() {
    let defaultButton = "btn btn-outline-dark btn-lg btn-block ";
    let styleGrade1 = { height: "50px", backgroundColor: "#ffffff" };
    let styleGrade2 = { height: "50px", backgroundColor: "#f2fbfd" };
    let styleGrade3 = { height: "50px", backgroundColor: "#e6f8fc" };
    let styleGrade4 = { height: "50px", backgroundColor: "#daf5fb" };
    let styleGrade5 = { height: "50px", backgroundColor: "#cef2fa" };

    let styleClicked = { height: "50px", backgroundColor: "#95e3f6" };
    let styleNotClicked = { height: "50px", backgroundColor: "#ffffff" };

    let modalClose = () => this.setState({ modalShow: false });

    let passGradetoParent = (grade) => {
      this.props.setRatingGrade(grade);
    };

    let setGrade = (grade) => {
      this.setState({ selectedGrade: grade });
      passGradetoParent(grade);
    };
    return (
      <div className="container-fluid row d-flex justify-content-center">
        <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
          <div className="card mb-4 box-shadow h-100 " id="pageContent_2">
            <ul className="list-group list-group-flush text-dark ">
              <li
                className="list-group-item form-card-1 form-card-selectable allign-items-center"
                onClick={() => this.setState({ modalShow: true })}
              >
                <div className="p-2" id="moduleContentText">
                  <center>
                    <span style={{ fontSize: "150%" }}>{this.props.title}</span>
                  </center>
                </div>
              </li>
              <li
                className="list-group-item"
                style={{ padding: "1px 5px", backgroundColor: "#2bc7ee" }}
              ></li>
              <li className="list-group-item form-card-2">
                <div className="btn-group-vertical d-flex button-grade">
                  <button
                    type="button"
                    className={defaultButton}
                    style={
                      this.state.selectedGrade == 1
                        ? styleClicked
                        : this.state.selectedGrade > 0
                        ? styleNotClicked
                        : styleGrade1
                    }
                    onClick={() => setGrade(1)}
                  >
                    LOW
                  </button>
                  <button
                    type="button"
                    className={defaultButton}
                    style={
                      this.state.selectedGrade == 2
                        ? styleClicked
                        : this.state.selectedGrade > 0
                        ? styleNotClicked
                        : styleGrade2
                    }
                    onClick={() => setGrade(2)}
                  ></button>
                  <button
                    type="button"
                    className={defaultButton}
                    style={
                      this.state.selectedGrade == 3
                        ? styleClicked
                        : this.state.selectedGrade > 0
                        ? styleNotClicked
                        : styleGrade3
                    }
                    onClick={() => setGrade(3)}
                  ></button>
                  <button
                    type="button"
                    className={defaultButton}
                    style={
                      this.state.selectedGrade == 4
                        ? styleClicked
                        : this.state.selectedGrade > 0
                        ? styleNotClicked
                        : styleGrade4
                    }
                    onClick={() => setGrade(4)}
                  ></button>
                  <button
                    type="button"
                    className={defaultButton}
                    style={
                      this.state.selectedGrade == 5
                        ? styleClicked
                        : this.state.selectedGrade > 0
                        ? styleNotClicked
                        : styleGrade5
                    }
                    onClick={() => setGrade(5)}
                  >
                    HIGH
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <ModalInfo
          show={this.state.modalShow}
          onHide={modalClose}
          title={this.props.modalTitle}
          content={this.props.modalDescription}
        />
      </div>
    );
  }
}

export default RatingActivity;
